import { render, staticRenderFns } from "./GroupInfoDialog.vue?vue&type=template&id=934e60b2&scoped=true"
import script from "./GroupInfoDialog.vue?vue&type=script&lang=js"
export * from "./GroupInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoDialog.vue?vue&type=style&index=0&id=934e60b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934e60b2",
  null
  
)

export default component.exports